import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const COLORS = [
  "#4A86E8",
  "#7C5CFC",
  "#20B86A",
  "#F59E0B",
  "#38BDF8",
  "#EF6C6C",
  "#8B6BA8",
];

const ProjectCostChart = ({
  projects = [],
}) => {

  // =========================================
  // COST DATA
  // =========================================

  const costData = projects.map(
    (project) => ({
      name:
        project.project_name ||
        project.project_code,

      value:
        Number(
          project.estimated_cost
        ) || 0,
    })
  );

  // =========================================
  // TOTAL COST
  // =========================================

  const totalCost = costData.reduce(
    (total, project) =>
      total + project.value,
    0
  );

  // =========================================
  // FORMAT CURRENCY
  // =========================================

  const formatCurrency = (value) => {
    return new Intl.NumberFormat(
      "en-IN",
      {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
      }
    ).format(value);
  };

  // =========================================
  // TOOLTIP
  // =========================================

  const CustomTooltip = ({
    active,
    payload,
  }) => {

    if (
      active &&
      payload &&
      payload.length
    ) {

      const project =
        payload[0];

      const percentage =
        totalCost > 0
          ? (
              (project.value /
                totalCost) *
              100
            ).toFixed(1)
          : 0;

      return (
        <div className="rounded-lg border border-gray-200 bg-white px-3 py-2 shadow-lg">

          <p className="mb-2 text-xs font-semibold text-gray-800">
            {project.name}
          </p>

          <p className="text-xs text-gray-600">
            Estimated Cost:{" "}
            <span className="font-semibold text-gray-900">
              {formatCurrency(
                project.value
              )}
            </span>
          </p>

          <p className="text-xs text-gray-600">
            Percentage:{" "}
            <span className="font-semibold text-gray-900">
              {percentage}%
            </span>
          </p>

        </div>
      );
    }

    return null;
  };

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4">

      {/* =====================================
          HEADER
      ===================================== */}

      <div>

        <h3 className="text-sm font-semibold text-slate-800">
          Project Cost
        </h3>

        <p className="mt-0.5 text-xs text-gray-500">
          Estimated cost distribution
        </p>

      </div>

      {/* =====================================
          TOTAL
      ===================================== */}

      <div className="mb-1 mt-3">

        <p className="text-xs text-gray-500">
          Total Estimated Cost
        </p>

        <p className="text-xl font-bold text-gray-800">
          {formatCurrency(totalCost)}
        </p>

      </div>

      {/* =====================================
          CHART
      ===================================== */}

      <div className="h-40">

        {costData.length === 0 ? (

          <div className="flex h-full items-center justify-center text-xs text-slate-500">
            No project data available
          </div>

        ) : (

          <ResponsiveContainer
            width="100%"
            height="100%"
          >

            <PieChart>

              <Pie
                data={costData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                innerRadius={35}
                outerRadius={58}
                paddingAngle={2}
              >

                {costData.map(
                  (_, index) => (
                    <Cell
                      key={index}
                      fill={
                        COLORS[
                          index %
                            COLORS.length
                        ]
                      }
                    />
                  )
                )}

              </Pie>

              <Tooltip
                content={
                  <CustomTooltip />
                }
              />

            </PieChart>

          </ResponsiveContainer>

        )}

      </div>

    </div>
  );
};

export default ProjectCostChart;